exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-loading{position:fixed;top:0;left:0;right:0;bottom:0;background-color:#fff;z-index:9999}.container-loading .loading{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:335px;font-size:30px;font-family:Roboto,sans-serif;color:#272727;font-weight:900}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/public/style.css
// module id = 297
// module chunks = 0